import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './change_lang.component.html'
})
export class ChangeLangModalComponent extends BaseSupportModalComponent {
	title: string;
	siteId: string;
	userId: string;
	domainUrl: string;
	newLang: string = '';

	async ok() {
		if (confirm(`Подтвердите смену языка для сайта ${this.domainUrl}?`)) {
			await this.supportService.changeLang(this.siteId, this.userId, this.newLang, this.spreader.base.comment).toPromise();
			
			this.execute();
		}		
	}
}
